<script>
  import { onMount } from "svelte";
  import { Chart, DateRangePicker, Card } from "../../components/index.svelte";
  import { calculateMonthlyPropertyEarnings } from "../../helpers/apiHelpers/property-management.rest.svelte";
  import { formatDate, toast, dateInitializer, currencyNameToSign } from "../../helpers/utils.svelte";
  import { translator } from "../../store";
  export let propertyID;
  export let currency;
  let chartData = null;

  let tempDate = dateInitializer();
  let defaultStartDate = dateInitializer(tempDate.getFullYear(), tempDate.getMonth() - 7, 1);
  let defaultEndDate = dateInitializer(tempDate.getFullYear(), tempDate.getMonth(), 0);
  onMount(async () => {
    await initializeChart(propertyID, null, null, currency);
  });

  $: {
    initializeChart(propertyID, null, null, currency);
  }

  async function onDateChange(startDate, endDate) {
    try {
      defaultStartDate = startDate.toDate();
      defaultEndDate = endDate.toDate();
      await initializeChart(propertyID, null, null, currency);
    } catch (err) {
      toast.error(
        translator("Hata"),
        err.getResponseMessage
          ? translator(err.getResponseMessage())
          : translator(err.message)
      );
    }
  };

  export async function initializeChart(propertyID, startDate = null, endDate = null, currencyProp) {
    if (!startDate && defaultStartDate) {
      startDate = formatDate(defaultStartDate, 'Y-md-d');
    }
    if (!endDate && defaultEndDate) {
      endDate = formatDate(defaultEndDate, 'Y-md-d');
    }
    const earningsResponse = await calculateMonthlyPropertyEarnings(
      startDate,
      endDate,
      propertyID
    );
    if (!earningsResponse) {
      throw new Error("Gelir/Gider verisi hesaplanamadı");
    }
    let formattedEarnings = {};
    let formattedExpenses = {};

    if (earningsResponse.calculation) {
      formattedEarnings = earningsResponse.calculation.reduce((acc, cur) => {
        acc[cur.months] = cur.monthly_earning;
        return acc;
      }, {});
    }

    if (earningsResponse.expenses) {
      formattedExpenses = earningsResponse.expenses.reduce((acc, cur) => {
        acc[cur.formatted_date] = cur.expense_sum;
        return acc;
      }, {});
    }
    let uniqueMonths = new Set([
      ...Object.keys(formattedEarnings),
      ...Object.keys(formattedExpenses),
    ]);

    let orderedMonths = [...uniqueMonths].sort((a, b) => dateInitializer(a).getTime() - dateInitializer(b).getTime());;

    let dataSet = orderedMonths.reduce((acc, monthString) => {
      let currentEarning = formattedEarnings[monthString] || 0;
      let currentExpense = formattedExpenses[monthString] || 0;
      acc.earnings.push(
        {
          x: formatDate(new Date(monthString), "MN Y"), 
          y: currentEarning
        }
      );
      acc.expenses.push(
        {
          x: formatDate(new Date(monthString), "MN Y"),
          y: currentExpense
        }
      );
      acc.incomes.push(
        {
          x: formatDate(new Date(monthString), "MN Y"),
          y: currentEarning - currentExpense
        }
      );
      return acc;
    }, {
      earnings: [],
      expenses: [],
      incomes: []
    });

    chartData = {
        series: [
          {
            name: translator('Gelirler'),
            data: dataSet.earnings
          },
          {
            name: translator('Masraflar'),
            data: dataSet.expenses
          },
          {
            name: translator('Net Kazanç'),
            data: dataSet.incomes
          }
        ],
        xaxis: {
          type: 'category'
        },
        yaxis: {
          labels: {
            formatter: function(value) {
              if (value) {
                return value.toFixed(2) + " " + (currencyNameToSign(currencyProp));
              }
              return value;
            }
          }
        },
        stroke: {
            show: true,
            curve: 'smooth',
            lineCap: 'butt',
            width: 3,

        },
        markers: {
          size: 5
        }
      };
  };

</script>

<Card headerText={translator("Gelir Grafiği")}>
  <div slot="card-actions">
    <DateRangePicker
      onChange={onDateChange}
      defaultStart={defaultStartDate}
      defaultEnd={defaultEndDate}
    />
  </div>
  <Chart
    series={chartData?.series}
    xaxis={chartData?.xaxis}
    yaxis={chartData?.yaxis}
    stroke={chartData?.stroke}
    markers={chartData?.markers}
    colors={["#008FFB", "#FA4443", "#4CAF50"]}
    chartType="line"
  />
</Card>
